import React,{ useEffect, useState} from 'react';
import { Card, Rate, Tag, Typography, Space, Row, Col } from 'antd';
import {

  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { BulbFilled } from '@ant-design/icons';
import ComparisonProductList from "../../components/common/ComparisonProductList";
import { FastCounter } from './FastCounter';

const { Title, Text } = Typography;

const TopValuePicksComparison = ({products,bestValueProducts,partialData,keyword,websiteDisplay=false,date,phoneNumber}) => {
  let recommendation = products?.recommendation;

  if(products?.highest_rated_product)
  {
    const productArray=[]
    productArray.push(products.highest_rated_product);
    productArray.push(products.lowest_price_product);
    productArray.push(products.best_value_product);
    products=productArray
  }
  else{
    products=products?.products || products?.top_products || partialData;
  }

  const labels = products!=null ? Object.fromEntries(
    [
      // generate up to 5 feature descriptions
      ...Array.from({ length: 5 }, (_, i) => {
        const key = `feature_${i + 1}_description`;
        const value = products[0]?.[key];
        return value ? [key, value] : null;
      }).filter(Boolean),

      // add extra keys if available
      ...(products[0]?.price_description
        ? [["price_description", products[0].price_description]]
        : []),

      ...(products[0]?.quality_description
        ? [["quality_description", products[0].quality_description]]
        : []),
    ]
  ) : {};

  return (
    <div style={{ padding: '0px 0px 0px 0px' }}>
      <div style={{ margin: '0 auto' }}>

      {websiteDisplay &&
      <>
      <Typography variant="h5" style={{ marginTop: "14px"}}>
      <b>Best Value, Top Rated & Budget as of {date}.</b>
      </Typography>
      {/* <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
        Here's what we mean by each:
      </Typography> */}
      <List>


  <ListItem style={{paddingBottom:"0px",paddingTop:"0px"}}>
    <ListItemText
      primary={
        <span>
          🏆 <b>Best Value :</b> Best mix of price per unit & quality (more for your money!)
        </span>
      }
      primaryTypographyProps={{ style: { fontSize: "14px" } }}
    />
  </ListItem>

  <ListItem style={{paddingBottom:"0px",paddingTop:"0px"}}>
    <ListItemText
      primary={
        <span>
          ⭐ <b>Top Rated :</b> Best customer reviews everywhere
        </span>
      }
      primaryTypographyProps={{ style: { fontSize: "14px" } }}
    />
  </ListItem>
  <ListItem style={{paddingBottom:"0px",paddingTop:"0px"}}>
    <ListItemText
      primary={
        <span>
          💰 <b>Budget :</b> Product to buy right now
        </span>
      }
      primaryTypographyProps={{ style: { fontSize: "14px" } }}
    />
  </ListItem>
</List>

      <Divider sx={{ my: 2 }} />
      </>
      }


        <Typography  style={{
          fontWeight:500,
          alignItems: 'center',
          // marginBottom: '1rem',
          marginTop:"6px",
          color: '#333',
          fontSize:'16px',
          // marginLeft:"8px"
        }}>
          {/* Searched <b><FastCounter targetNumber={8000} speed={20} /> products</b> across <b>8+ stores</b> {keyword ? "for" : ""} <b>{keyword}</b>. */}
        {/* {partialData?.length === 0 && <>Searched <FastCounter targetNumber={8000} speed={20} /> products {keyword ? "for" : ""} <b>{keyword}</b>  across 8+ stores.</> } */}
        </Typography>

        {/* <div style={{paddingLeft:"12px", marginBottom:"10px"}}>
          <Text style={{
            fontSize: '12px',
            fontWeight: 'bold',

            lineHeight: '1'
          }}>
            {recommendation}
          </Text>
        </div> */}

        <div style={{ gap: '0px', alignItems: 'flex-start' }}>
          {/* Labels Column */}
          {/* <div style={{
            paddingTop: '140px' // Align with product content
          }}> */}
            {/* {labels.map((label, index) => (
              <div key={index} style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                marginBottom: index < labels.length - 1 ? '0px' : '0'
              }}>
                <Text strong style={{
                  fontSize: '13px',
                  color: '#666',
                  textAlign: 'right',
                  width: '100%'
                }}>
                  {label}
                </Text>
              </div>
            ))} */}
          {/* </div> */}

          {/* Product Cards */}
          {/* <div style={{
            display: 'flex',
            flex: 1
          }}> */}

{/* enable for top pick comparison */}
            {partialData.length > 0 &&
            <ComparisonProductList products={products} labels={labels} bestValueProducts={bestValueProducts} partialData={partialData} phoneNumber={phoneNumber}/>
            }

            {/* {products.map((product) => (
              <ComparisonProductList key={product.id} product={product} />
            ))} */}
          {/* </div> */}
          {websiteDisplay &&
        <Typography>
        Buying guide last updated at {date}.
        </Typography>
}
        </div>


      </div>
    </div>
  );
};

export default TopValuePicksComparison;